import { makeStyles } from '@mui/styles';

const useDivisionDetailsStyles = makeStyles({
	root: {
		display: 'flex',
		flexFlow: 'row wrap',
		gap: '24px 72px',
		padding: 24,
		textAlign: 'left',
		width: '100%',
	},
});

export default useDivisionDetailsStyles;
